import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { UseReportSettingsModalProvider } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.provider';
import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings.module.scss';
import { AccessOptionSelection } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/AccessOptionSelection/AccessOptionSelection';
import { AllUsersAccess } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/AllUsersAccess/AllUsersAccess';
import { SpecificUsersAccess } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/SpecificUsersAccess';

interface Props {
    api: UseReportSettingsModalProvider['api'];
}

export const ReportAccessSettings = ({ api }: Props) => {
    // form context
    const { control } = useFormContext<FormValues>();

    const accessOption = useWatch({ control, name: 'accessListOption' });

    return (
        <div className={classes.ShareAccessContainer}>
            <AccessOptionSelection accessOption={accessOption} />
            <div className={classes.accessOptions}>
                <div className={accessOption === 'whole' ? '' : classes.hidden}>
                    <AllUsersAccess />
                </div>

                <div className={accessOption === 'specific' ? classes.individualAccess : classes.hidden}>
                    <SpecificUsersAccess api={api} />
                </div>
            </div>
        </div>
    );
};
